import { useFlags } from 'launchdarkly-react-client-sdk'
import { useSelector } from 'react-redux'
import { useContext } from 'react'
import { SessionContext } from 'src/features/session/SessionContext'
import { getConfig } from 'src/features/config/ConfigSelector'

const useLaunchDarkly = () => {
  const flags = useFlags()
  const session = useContext(SessionContext)

  const featureFlagConfig = useSelector(getConfig('feature_flag_ldk')) || null

  const validateMenuItem = item => {
    if (item?.featureFlag) return showForFeatureFlag(item)
    if (item?.licenseType) return showForLicenseType(item)
    if (item?.to === '/river/library-picks') return showForLibraryPicks(item)
    return item
  }

  const showForFeatureFlag = item => {
    if (flags[item?.featureFlag]) return item
    return item?.featureFlagFallback || null
  }

  const showForLicenseType = item => {
    const { checked: sessionReady, user } = session
    const { licenseType = null } = item
    if (
      sessionReady &&
      user?.license_types?.find(item => item?.name === licenseType)
    ) {
      return item
    }
    return item?.featureFlagFallback || null
  }

  const showForLibraryPicks = item => {
    const { checked: sessionReady, user } = session
    if (!sessionReady || !user?.derived_company?.company_name) return null
    return {
      ...item,
      label: `${user?.derived_company?.company_name} Library Picks`
    }
  }

  const getFeatureFlagMenuItem = item => {
    if (item?.group) {
      if (item?.content) {
        const itemCopy = { ...item, content: [] }
        if (Array.isArray(item?.content)) {
          for (const groupItem of item.content) {
            const validatedGroupItem = validateMenuItem(groupItem)
            if (validatedGroupItem) {
              itemCopy.content.push({ ...validatedGroupItem })
            }
          }
        }
        return itemCopy
      }
      return item
    } else {
      return validateMenuItem(item)
    }
  }

  return {
    flags,
    featureFlagConfig,
    getFeatureFlagMenuItem,
    validateMenuItem
  }
}

export default useLaunchDarkly
